<template>
  <!-- Header bar -->
  <nav class="top-menu">

    <!-- i18n menu -->
    <div class="lang-menu">
      <svg-icon name="globe" class="simple-icon" :title="$t('locale')"/>
      <router-link
        v-for="lang of config.locales"
        :key="lang.code"
        :to="{name: $route.name, params: {lang: lang.code}}"
        :disabled="$i18n.locale === lang.code"
        :title="$t(lang.name)">
        {{ lang.code }}
      </router-link>
    </div>

    <div class="main-menu">
      <transition name="fade" mode="out-in">
        <router-link
          v-if="$route.name != 'home'"
          :to="{ name: 'home', params: {lang: $route.params.lang}}">
          <svg-icon name="home"/>
        </router-link>
        <span v-else/>
      </transition>

      <transition name="fade" mode="out-in">
        <router-view v-if="$route.matched[0].components.menu" name="menu"></router-view>
        <span v-else/>
      </transition>
    </div>

  </nav>
</template>

<script>
import config from '@/../data/config.yaml'

export default {
  data () {
    return {
      config
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NavMenu.vue